/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0
 * @access public
 * @return void
 */
export function flickitySlideshowOptions() {
	/**
	 * Variables used for our custom slider
	 *
	 * Play with the `tickerSpeed` value to change the speed
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 */
	let tickerSpeed   = 2;
	let flickity      = null;
	let isPaused      = false;
	const slideshowEl = document.querySelector( '.js-slideshow' );


	/**
	 * Slider custom functions
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 */
	const update = () => {
		if ( isPaused ) return;
		if ( flickity.slides ) {
			flickity.x             = (flickity.x - tickerSpeed) % flickity.slideableWidth;
			flickity.selectedIndex = flickity.dragEndRestingSelect();
			flickity.updateSelectedSlide();
			flickity.settle( flickity.x );
		}
		window.requestAnimationFrame( update );
	};

	const pause = () => {
		isPaused = true;
	};

	const play = () => {
		if ( isPaused ) {
			isPaused = false;
			window.requestAnimationFrame( update );
		}
	};


	/**
	 * Create Slider based on Flickity Slider library
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 */
	flickity = new Flickity( slideshowEl, {
		autoPlay: false,
		prevNextButtons: true,
		pageDots: false,
		draggable: true,
		wrapAround: true,
		selectedAttraction: 0.015,
		friction: 0.25
	} );
	flickity.x = 0;


	/**
	 * Add Event Listeners to trigger specific events
	 * on the slider like `play` and `pause`
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 */
	slideshowEl.addEventListener( 'mouseenter', pause, false );
	slideshowEl.addEventListener( 'focusin', pause, false );
	slideshowEl.addEventListener( 'mouseleave', play, false );
	slideshowEl.addEventListener( 'focusout', play, false );

	flickity.on( 'dragStart', () => {
		isPaused = true;
	} );


	/**
	 * Start the slider
	 *
	 * @since  1.0.0
	 * @access public
	 * @return void
	 */
	update();

}
